export default "__VITE_ASSET__a2adc733__"